import React from 'react';
import Grid from '@material-ui/core/Grid';
import { setStep1 } from "../../application/actions";
import { useForm, useFormState } from "react-hook-form";
import { useAppState } from "../../application/AppState";
import TextField from '@material-ui/core/TextField';
import WizardButtons from './WizardButtons';
import useTranslation from "../../application/translation";
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { getDefaultValue2 } from "../../application/helpers/form";

export default function Step1PersonalInfo({ handleBack, handleNext }) {
    const [{ formValues, customer }, dispatch] = useAppState();
    const translation = useTranslation();

    const requiredObj = {
        required_error: translation.error_mandatory,
    };

    const formSchema = z.object({
        email: z.string(requiredObj).email({ message: translation.error_invalidemail }),
    });

    const formType = Step1PersonalInfo.name;

    const { formState, register, handleSubmit, control } = useForm({
        mode: "onChange",
        defaultValues: {
            fullName: `${customer.firstName} ${customer.lastName}`,
            email: getDefaultValue2(formValues, formType, "email"),
        },
        resolver: zodResolver(formSchema),
    });

    const { isValid, isSubmitting, errors } = useFormState({ control });

    const onSubmit = (data) => {
        dispatch(setStep1(data));
        handleNext();
    };

    return (
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} aria-label="Personlig information">
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="fullName"
                        {...register("fullName")}
                        disabled
                        label={translation.step1_names}
                        variant="outlined"
                        fullWidth
                        inputProps={{ 'aria-label': translation.step1_names }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="email"
                        {...register("email")}
                        label="E-post"
                        variant="outlined"
                        disabled={isSubmitting}
                        fullWidth
                        inputProps={{ 'aria-label': 'E-postadress' }}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                    />
                </Grid>
            </Grid>
            <WizardButtons handleBack={handleBack} isStepValid={isValid} />
        </form>
    );
}
